module.exports = __webpack_public_path__ + "static/media/cosentino-workwear.830880a9.jpg";